import req from 'superagent';
import actionTypes from './actionTypes';

export const httpMethods = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE'
};

const reqFns = {
    [httpMethods.GET]: req.get,
    [httpMethods.POST]: req.post,
    [httpMethods.PUT]: req.put,
    [httpMethods.PATCH]: req.patch,
    [httpMethods.DELETE]: req.delete
};

const getQueryKey = ({ url }) => url;

const handlePropError = message => {
    console.warn(message);
    return Promise.reject(message);
};

const simpleTransform = (storeKey, normalizeProp) => body => {
    return {
        [storeKey]: body.reduce((acc, cur) => {
            acc[cur[normalizeProp]] = cur;
            return acc;
        }, {})
    };
};

export const UPDATE_DEFAULT = {
    MERGE: (cur, next) => ({ ...cur, ...next }),
    LATEST: (cur, next) => next
};

const getSimpleUpdate = (storeKey, update) => {
    if (typeof update === 'function') {
        return {
            [storeKey]: update
        };
    }
    return typeof update === 'object'
        ? update
        : {
              [storeKey]: UPDATE_DEFAULT.LATEST
          };
};

const simpleList = (storeKey, normalizeProp) => body => {
    return {
        [storeKey]: () => body.map(item => item[normalizeProp])
    };
};

const getResolvers = ({ normalizeProp, storeKey, transform, update, list }) => {
    if (transform && update) {
        return {
            entities: transform,
            update,
            list
        };
    }
    if (normalizeProp && storeKey) {
        return {
            entities: simpleTransform(storeKey, normalizeProp),
            list: simpleList(storeKey, normalizeProp),
            update: getSimpleUpdate(storeKey, update)
        };
    }
    return null;
};

const getReqFn = options => {
    const method = options.method || httpMethods.GET;
    const fn = reqFns[method];
    if (!fn) {
        return fn;
    }
    if (options.withCredentials) {
        return fn.withCredentials();
    }
    return fn;
};

export const requestAsync = ({
    url,
    body,
    normalizeProp,
    storeKey,
    transform,
    update,
    list,
    nextAction,
    queryKey = getQueryKey({ url }),
    options = {}
}) => (dispatch, getState) => {
    if (!url) {
        return handlePropError('No url specified');
    }
    if (normalizeProp && transform) {
        return handlePropError('normalizeProp and transform cannot be used together');
    }
    if (storeKey && transform) {
        return handlePropError('storeKey and transform cannot be used together');
    }
    const resolvers = getResolvers({
        normalizeProp,
        storeKey,
        transform,
        update,
        list
    });
    if (!resolvers) {
        return handlePropError('Prop error');
    }
    dispatch({ type: actionTypes.REQUEST_START, url, queryKey });
    const reqFunction = getReqFn(options);
    if (!reqFunction) {
        return handlePropError(`Wrong httpMethod specified ${options.method}`);
    }
    return reqFunction(url, body)
        .then(response => {
            const { body, status } = response;
            const transformedEntities = resolvers.entities(body);
            const { requery } = getState();
            const updatedEntites = Object.keys(resolvers.update).reduce((acc, key) => {
                const updateFn = resolvers.update[key];
                const cur = requery.entities[key];
                const next = transformedEntities[key];
                acc[key] = updateFn(cur, next);
                return acc;
            }, {});
            const totalEntities = { ...requery.entities, ...updatedEntites };
            const listObj = resolvers.list(body);
            const listItems = Object.keys(listObj).reduce((acc, key) => {
                const prevListArray = Array.isArray(requery.list[key]) ? requery.list[key] : [];
                acc[key] = listObj[key](prevListArray, body);
                return acc;
            }, {});
            const totalList = { ...requery.list, ...listItems };

            dispatch({
                type: actionTypes.REQUEST_SUCCESS,
                entities: totalEntities,
                list: totalList,
                status,
                queryKey
            });

            if (nextAction) {
                const action = nextAction();

                dispatch({
                    ...action,
                    type: action.type,
                    payload: {
                        ...action.payload,
                        entities: totalEntities,
                        list: totalList
                    }
                });
            }

            return {
                body,
                status,
                entities: totalEntities,
                list: totalList,
                updated: updatedEntites
            };
        })
        .catch(error => {
            const { status = 0 } = error;
            dispatch({ type: actionTypes.REQUEST_FAILURE, status, queryKey });
            throw error;
        });
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/requery/actions.js
 **/